import { useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './orderbox.scss';
import { useEffect, useState } from 'react';
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import { useAuth } from '../../context/AuthContext';
import UserEntry from '../UserEntry/UserEntrySection';
import { getBilling, loadCoupons } from '../../api/requests';
import { useNotification } from '../../context/NotificationContext';
import { Coupon } from '../../interface/interfaces';
import { X, Ticket } from 'lucide-react';
import { usePrompt } from '../../context/PromptContext';

const OrderBox = () => {
 const location = useLocation();
 const { notify } = useNotification();
 const navigate = useNavigate();
 const { cartData } = useCart();
 const [userEntry, setUserEntry] = useState(false);
 const { isLoggedIn, setAuthRedirect } = useAuth();
 const { initPrompt } = usePrompt();

 type pageDataProps = {
  allCoupon: Coupon[];
  isLoading: boolean;
 };

 const [pageData, setPageData] = useState<pageDataProps>({
  allCoupon: [],
  isLoading: false,
 });

 const [orderSummary, setOrderSummary] = useState({
  cartTotal: 0,
  shippingfee: 0,
  vat: 0,
  coupondiscount: 0,
  orderTotal: 0,
  currency_data: {
   currency_symbol: '₦',
  },
 });

 type couponProp = {
  coupon: string;
  metadata: Coupon | null;
  isLoading: boolean;
 };

 const [couponData, setCouponData] = useState<couponProp>({
  coupon: '',
  metadata: null,
  isLoading: false,
 });

 const [checkoutLoader, setCheckoutLoader] = useState(false);

 function getDiscountAmount(cartTotal: number) {
  if (couponData.metadata) {
   let amt =
    cartTotal * (couponData.metadata.discount_percentage / 100);
   return amt;
  } else {
   return 0;
  }
 }

 function calculateSummary() {
  let cartTotal = 0;
  let orderTotal = 0;

  cartData.forEach((data) => {
   cartTotal += data.totalAmount;
  });

  let discountAmt = getDiscountAmount(cartTotal);

  orderTotal =
   cartTotal +
   orderSummary.shippingfee +
   orderSummary.vat -
   discountAmt;

  setOrderSummary((prev) => {
   return {
    ...prev,
    cartTotal: cartTotal,
    orderTotal: orderTotal,
    coupondiscount: discountAmt,
   };
  });
 }

 const setPageLoader = (value: boolean) => {
  setPageData((prev) => {
   return {
    ...prev,
    isLoading: value,
   };
  });
 };

 useEffect(() => {
  (async () => {
   try {
    setPageLoader(true);

    let { coupons } = await loadCoupons(1, 100);

    setPageData((prev) => {
     return {
      ...prev,
      allCoupon: coupons,
     };
    });

    const query = new URLSearchParams(location.search);
    const coupon_id = query.get('coupon_id');

    if (coupon_id && coupon_id !== '') {
     // let couponData = await getCoupon(coupon_id)

     let couponData = coupons.find((data) => {
      return data.id === coupon_id;
     });

     if (couponData) {
      setCouponData((prev) => {
       return {
        ...prev,
        metadata: couponData!,
       };
      });
     } else {
      notify.error('Invalid coupon!');
     }
    }
   } catch (error) {
    console.error(error);
   } finally {
    setPageLoader(false);
   }
  })();

  // eslint-disable-next-line
 }, [location.search]);

 useEffect(() => {
  calculateSummary();
  // eslint-disable-next-line
 }, [cartData, couponData.metadata]);

 const isBillingAvailable = async () => {
  try {
   setCheckoutLoader(true);

   let bdat = await getBilling();

   if (bdat.length >= 1) {
    return true;
   }
  } catch (error) {
   console.error(error);
  } finally {
   setCheckoutLoader(false);
  }

  return false;
 };

 const goTo = (page: string) => {
  navigate(page);
 };

 const handleCouponInput = (val: string) => {
  setCouponData((prev) => {
   return {
    ...prev,
    coupon: val,
   };
  });
 };

 // const setCouponLoader = (value: boolean) => {
 //   setCouponData((prev) => {
 //     return {
 //       ...prev,
 //       isLoading: value
 //     }
 //   })
 // }

 const handleApplyCoupon = async () => {
  if (isLoggedIn()) {
   let couponResp = pageData.allCoupon.find((data) => {
    return data.coupon_code === couponData.coupon;
   });

   if (couponResp) {
    setCouponData((prev) => {
     return {
      ...prev,
      metadata: couponResp!,
     };
    });
   } else {
    notify.error('Invalid coupon code');
   }
  } else {
   setAuthRedirect({
    pageUrl: '/cart',
   });

   setUserEntry(true);
  }
 };

 const handleCheckout = async () => {
  if (isLoggedIn()) {
   let billingCheck = await isBillingAvailable();

   if (billingCheck) {
    // let stateData={
    //   orderSummary:orderSummary,
    //   couponData: couponData.metadata ? couponData.metadata : null
    // }

    if (couponData.metadata) {
     navigate(`/checkout/${couponData.metadata.id}`);
    } else {
     navigate(`/checkout`);
    }
   } else {
    navigate('/cart/addbilling');
    notify.info('Please add a delivery info to proceed');
   }
  } else {
   setAuthRedirect({
    pageUrl: '/cart',
   });

   setUserEntry(true);
  }
 };

 const handleCouponDelete = () => {
  const callback = () => {
   setCouponData((prev) => {
    return {
     ...prev,
     metadata: null,
    };
   });
  };

  initPrompt(
   'Remove coupon',
   'Do you want to remove this coupon?',
   callback,
  );
 };

 return (
  <div className="ord">
   <div className="orderbox">
    <div className="title">Order summary</div>

    {pageData.isLoading && (
     <div className="spinnerpack">
      <div className="bigspinner"></div>
     </div>
    )}

    {!pageData.isLoading && (
     <>
      <div className="orderinfo">
       <div className="eachinfo">
        <div className="info">Items</div>
        <div className="value">{cartData.length}</div>
       </div>

       <div className="eachinfo">
        <div className="info">Sub Total</div>
        <div className="value">
         {orderSummary.currency_data.currency_symbol}
         {orderSummary.cartTotal.toLocaleString()}
        </div>
       </div>

       {/* <div className='eachinfo'>
            <div className='info'>Shipping</div>
            <div className='value'>{orderSummary.currency_data.currency_symbol}{(orderSummary.shippingfee).toLocaleString()}</div>
          </div> */}

       {/* <div className='eachinfo'>
            <div className='info'>VAT</div>
            <div className='value'>{orderSummary.currency_data.currency_symbol}{(orderSummary.vat).toLocaleString()}</div>
          </div> */}

       <div className="eachinfo discount">
        <div className="info">Coupon discount</div>
        <div className="value">
         <span>- </span>
         {orderSummary.currency_data.currency_symbol}
         {orderSummary.coupondiscount.toLocaleString()}
        </div>
       </div>
      </div>

      <hr className="line"></hr>

      <div className="eachinfo totalbal">
       <div className="info">Total</div>
       <div className="value">
        {orderSummary.currency_data.currency_symbol}
        {orderSummary.orderTotal.toLocaleString()}
       </div>
      </div>

      <div className="btn-pack">
       {cartData.length >= 1 && (
        <LoaderBtn
         className={'checkout-btn'}
         clickFunction={handleCheckout}
         text={'Proceed to checkout'}
         thickness={3}
         isLoading={checkoutLoader}
        ></LoaderBtn>
       )}

       {cartData.length <= 0 && (
        <button
         className="checkout-btn"
         onClick={() => goTo('/products')}
        >
         Continue Shooping
        </button>
       )}
      </div>
     </>
    )}
   </div>

   {!couponData.metadata && (
    <div className="couponBox">
     <input
      placeholder="Enter coupon code"
      value={couponData.coupon}
      onChange={(e) => handleCouponInput(e.currentTarget.value)}
     ></input>
     <LoaderBtn
      text={'Apply'}
      clickFunction={handleApplyCoupon}
      thickness={3}
      isLoading={couponData.isLoading}
      className={'btn'}
     ></LoaderBtn>
    </div>
   )}

   {couponData.metadata && (
    <div className="couponDisplay">
     <div className="upside">
      <div>
       <div className="ccode">{couponData.metadata.coupon_code}</div>
      </div>

      <div className="flexv">
       <Ticket
        size={12}
        color="var(--black-tint-three)"
       ></Ticket>
       <span className="xk">coupon</span>
      </div>
     </div>

     <div className="coupflex">
      <div className="text">
       <div className="percOff">
        {couponData.metadata.discount_percentage}% off
       </div>
       <div className="name">{couponData.metadata.offer_name}</div>
      </div>

      <div
       className="deletebtn"
       onClick={handleCouponDelete}
      >
       <X size={14}></X>
      </div>
     </div>
    </div>
   )}

   <UserEntry
    toggle={userEntry}
    setToggle={setUserEntry}
   ></UserEntry>
  </div>
 );
};

export default OrderBox;
